import { createContext, useContext } from 'react';
import { AttributeReferenceConfig } from 'pages/Financials/financials-widget-drawer/types';
import { HandlePushingAttributeMappingsPayload } from './attribute-mapped-widget-drawer.types';
import { ClearAttributeMappingsPayload } from '../../../services/sheet-attribute-manager/models/sheet-attribute-manager.interface';
import SheetAttributeManager from '../../../services/sheet-attribute-manager/SheetAttributeManager';
import WidgetDrawerProps from '../widget-drawer/WidgetDrawer.props';

export interface CitationPushedPayload {
  selectedText: string;
  tokenIds: number[];
  page: number;
  rects: { left: number; top: number; width: number; height: number }[];
}

export const AttributeMappedWidgetDrawerContext = createContext<{
  attributeMapper?: SheetAttributeManager;
  attributeReferenceConfig?: AttributeReferenceConfig;
  handlePushingAttributeMappings?: (payload?: HandlePushingAttributeMappingsPayload) => void;
  handleClearMappings?: (docRefPayload?: ClearAttributeMappingsPayload) => void;
  onCitationPushed?: (payload: CitationPushedPayload, documentReferenceId: number) => void;
    }>({});

export const useAttributeMappedWidgetDrawer = () => useContext(AttributeMappedWidgetDrawerContext);

export interface AttributeMappedWidgetDrawerProps extends WidgetDrawerProps {
  attributeMapper?: SheetAttributeManager;
  attributeReferenceConfig: AttributeReferenceConfig;
  handlePushingAttributeMappings?: (payload?: HandlePushingAttributeMappingsPayload) => void;
  handleClearMappings?: (docRefPayload?: ClearAttributeMappingsPayload) => void;
  onCitationPushed?: (payload: CitationPushedPayload, documentReferenceId: number) => void;
}
